import React from 'react';
import LatestNewsWidget from "../components/newsAndEvents/LatestNewsWidget";

const RecentActivities = () => {
  return (
    <div className="container mx-auto py-12 px-4">
      <h1 className="text-4xl font-bold text-center mb-8">Recent Activities</h1>
      <p className="text-center text-gray-600 mb-8 text-lg">Stay updated with the latest activities and news.</p>
      <div className="max-w-6xl mx-auto">
        <LatestNewsWidget />
      </div>
    </div>
  );
};

export default RecentActivities;